import { render, staticRenderFns } from "./wirteRuleFeeRemarkList.vue?vue&type=template&id=50bd4762&scoped=true"
import script from "./wirteRuleFeeRemarkList.vue?vue&type=script&lang=js"
export * from "./wirteRuleFeeRemarkList.vue?vue&type=script&lang=js"
import style0 from "./wirteRuleFeeRemarkList.vue?vue&type=style&index=0&id=50bd4762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd4762",
  null
  
)

export default component.exports